import PropTypes from 'prop-types';
import IconButton from 'Components/Atoms/IconButtonBare';
import Icon from 'Components/Atoms/Icon/Icon';

export default function SnackbarClose({ onClick }) {
    return (
        <div className="absolute top-2 right-2">
            <IconButton onClick={onClick}>
                <Icon name="close" color="#CDCDCD" size={16} />
            </IconButton>
        </div>
    );
}

SnackbarClose.propTypes = {
    onClick: PropTypes.func.isRequired,
};
